interface VimConfig {
  clientId: string;
  clientSecret: string;
  host: string;
  httProtocol: string;
  wsProtocol: string;
  scope: string;
  httPort: number;
  wsPort: number;
}

const vimConfig: VimConfig = {
  clientId: "app",
  clientSecret: "app",
  host: "192.168.88.88",
  // host: "chat.123ai.pro",
  httProtocol: "https",
  wsProtocol: "wss",
  scope: "server",
  httPort: 8088,
  wsPort: 9326,
};
// console.log('host'+vimConfig.host)
// console.log(window.location.origin)

if (window.location.origin.indexOf("ai.123vp.com") > -1) {
  vimConfig.host="ai.123vp.com/api"
} else if(window.location.origin.indexOf("114.242.3.137:8888") > -1){
    vimConfig.host = '114.242.3.137:8888/api'
}

export default vimConfig;
